<template>
  <div class="part--part-spec-properties-form" id="part-spec-properties-form">
    <Spin v-if="loading"></Spin>
    <Row v-else :gutter="32" index="">
      <Col span="12">
        <!-- add specification property field -->
        <div class="ivu-form-item">
          <Row :gutter="32">
            <Col span="18">
              <Select v-model="selectedMetadata" placeholder="Add specification property" filterable clearable
                      v-if="specMetadatas">
                <Option v-for="item in specMetadatas" :value="item.key" :key="item.key">{{ item.name }} {{
                  item.chinese_name ? `/ ${item.chinese_name}` : ''}}
                </Option>
              </Select>
            </Col>
            <Col span="6">
              <Button type="primary" @click="handleAddSpecification" :disabled="!selectedMetadata">{{ $t('add') }}
              </Button>
            </Col>
          </Row>
        </div>
        <!-- add specification property field end -->
      </Col>
    </Row>
    <div class="component-spec-properties">
      <!-- Specification properties form -->
      <Form v-if="specValues && specValues.length > 0 && ended" inline ref="partSpecValuesForm">
        <!-- specification properties -->
        <Row :gutter="16">
          <Col span="8" v-for="specValue in specValues" :key="specValue.key">
            <FormItem :label="specValue.meta.name" style="width: 100%;" v-if="specValue.meta" :required="isRequiredSpecValue(specValue)">
              <div v-if="checkIfUseAutoComplete(specValue)">
                <AutoComplete
                  v-model="specValue.value"
                  :data="getSpecValueSearchData(specValue)"
                  clearable>
                    <Option v-for="item in getSpecValueSearchData(specValue)" :value="item" :key="item">{{ item }}</Option>
                </AutoComplete>
              </div>
              <Input v-else :suffix="specValue.meta.is_main ? 'md-bulb' : ''" v-model="specValue.value"
                     :placeholder="specValue.display_value">
              </Input>
              <div class="short-desc">{{ specValue.meta.chinese_name ? specValue.meta.chinese_name : 'N/A' }}</div>
            </FormItem>
          </Col>
        </Row>
        <!-- specification properties end -->

        <!-- action to override specfication field -->
        <Row :gutter="16" class="text-align-right">
          <Col offset="18" span="6">
            <Button type="primary" @click="handleSaveSpecs" :saving="saving">{{ $t('save') }}</Button>
          </Col>
        </Row>
        <!-- action to override specfication field end -->
      </Form>
      <!-- Specification properties form end -->
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PartSpecPropertiesForm',
  props: {
    manufacturerPart: {
      type: Object,
      required: true
    },
    categoryId: {
      required: true
    },
    specAttributes: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  },
  data () {
    return {
      selectedMetadata: null,
      mainSpecMetas: [],
      saving: false,
      specValues: [],
      ended: false,
      specValuesData: [],
      casePackageSpecValues: [],
      mslSpecValues: []
    }
  },
  computed: {
    ...mapState({
      specMetadatas: state => state.part.specMetadatas
    }),
    partId () {
      return this.$route.params.partId
    }
  },
  mounted () {
    this.specValues = _.cloneDeep(this.specAttributes)
    this.getPartSpecMetadatas()
    this.loadCategoryData()
    this.setCasePackageMslSpecValues()
    this.handleSearchSpecValues()
  },
  watch: {
    loading: function (newVal) {
      if (newVal === false && this.specAttributes?.length > 0) {
        this.specValues = _.cloneDeep(this.specAttributes)
      }
    }
  },
  methods: {
    ...mapActions([
      'getPartSpecMetadatas',
      'updateElectronicPartSpec',
      'updateMechanicalPartSpec',
      'getPartCategory',
      'searchPartSpecifications'
    ]),
    loadCategoryData () {
      this.getPartCategory(this.categoryId).then(resp => {
        this.mainSpecMetas = resp?.main_specs
        this.setDefaultSpecValues(this.mainSpecMetas)
      })
    },
    setDefaultSpecValues (mainSpecMetas) {
      _.each(mainSpecMetas, (meta) => {
        if (!(_.find(this.specValues, (item) => {
          if (item.key === meta.key) {
            item.meta.is_main = true
          }
          return item.key === meta.key
        }))) {
          meta.is_main = true
          this.specValues.push({ meta: meta, key: meta.key, value: meta.value })
        }
      })
      this.ended = true
    },
    handleAddSpecification: function () {
      let specMeta = _.find(this.specMetadatas, (meta) => {
        return meta && meta.key === this.selectedMetadata
      })
      this.setSpecMeta(specMeta)
    },
    setSpecMeta (specMeta) {
      if (specMeta) {
        let find = _.find(this.specValues, (meta) => {
          return meta && meta.key === specMeta.key
        })

        if (!find) {
          this.specValues.push({
            key: specMeta.key,
            meta: specMeta,
            value: ''
          })
          this.$Message.success(this.$t('part.part_spec_add_success_tip'))
        } else {
          this.$Message.info(this.$t('part.part_spec_add_fail_tip'))
        }
      }
    },
    handleSaveSpecs: function () {
      this.$refs['partSpecValuesForm'].validate((valid) => {
        if (valid) {
          this.saving = true
          if (this.manufacturerPart.component_type === 'mechanical_part') {
            this.updateMechanicalPartSpec({
              id: this.partId,
              data: this.specValues
            }).then((res) => {
              this.$Message.success(this.$t('part.part_spec_save_tip'))
              this.$emit('specs-saved', res)
            }).finally(() => {
              this.saving = false
            })
          }
          if (this.manufacturerPart.component_type === 'electronic_part') {
            this.updateElectronicPartSpec({
              id: this.partId,
              data: this.specValues
            }).then((res) => {
              this.$Message.success(this.$t('part.part_spec_save_tip'))
              this.$emit('specs-saved', res)
            }).finally(() => {
              this.saving = false
            })
          }
        } else {
          this.$Message.error('Please provide values for the required fields')
        }
      })
    },
    setCasePackageMslSpecValues () {
      let casePackageMslSpecMeta = _.filter(this.specMetadatas, (meta) => {
        if (meta && meta.key === 'case_package') {
          return true
        }
        if (meta.key === 'moisture_sensitivity_level') {
          return true
        }
      })
      casePackageMslSpecMeta.forEach(specMeta => {
        this.setSpecMeta(specMeta)
      })
    },
    checkIfUseAutoComplete (specValue) {
      switch (specValue.key) {
        case 'case_package':
          return true
        case 'moisture_sensitivity_level':
          return true
        default:
          return false
      }
    },
    getSpecValuesSearchFilters () {
      return {
        keyword: '',
        matches: {},
        terms: {},
        specs: {},
        exists: {},
        includes: [],
        aggs: {
          min_value: {
            terms: {
              field: "min_value",
              size: 100
            }
          },
          max_value: {
            terms: {
              field: "max_value",
              size: 100
            }
          },
          key: {
            terms: {
              field: "key",
              size: 100
            }
          },
          value: {
            terms: {
              field: "value",
              size: 100
            }
          },
          values: {
            terms: {
              field: "values",
              size: 100
            }
          }
        },
        size: 30
      }
    },
    handleSearchSpecValues () {
      this.searchPartSpecifications(this.getSpecValuesSearchFilters()).then((res) => {
        if (res.data) {
          _.forEach(res.data, (specVal) => {
            if (specVal.key === 'case_package') {
              if (!this.casePackageSpecValues.includes(specVal.value)) {
                this.casePackageSpecValues.push(specVal.value)
              }
            }
            if (specVal.key === 'moisture_sensitivity_level') {
              if (!this.mslSpecValues.includes(specVal.value)) {
                this.mslSpecValues.push(specVal.value)
              }
            }
          })
        }
      }).finally(() => {
      })
    },
    getSpecValueSearchData (specValue) {
      switch (specValue.key) {
        case 'case_package':
          return this.casePackageSpecValues
        case 'moisture_sensitivity_level':
          return this.mslSpecValues
        default:
          return []
      }
    },
    isRequiredSpecValue (specValue) {
      switch (specValue.key) {
        case 'case_package':
          return true
        case 'moisture_sensitivity_level':
          return false
        default:
          return false
      }
    }
  }
}
</script>

<style lang="less">
  #part-spec-properties-form {
    .short-desc {
      font-size: 9px;
      color: gray;
      line-height: 14px;
    }

    .ivu-form .ivu-form-item-label {
      overflow-x: hidden;
      white-space: nowrap;
    }
  }
</style>
